import React, { useEffect, useRef, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";

import tradeIcon from "../../../assets/img/Trade.svg";
import systemIcon from "../../../assets/img/systm.svg";
import subSystemIcon from "../../../assets/img/sub-systm.svg";
import docIcon from "../../../assets/img/doc.svg";
import buildingIcon from "../../../assets/img/buildings.svg";
import {
    getAddressFromCoordinates,
    renderFileSize,
    toTitleCase,
    resetCursor,
    getFileExtension,
    showAlert as showAlertUtil
} from "../../../config/utils";
import moment from "moment";
import CopyToClipboard from "react-copy-to-clipboard";
import ReactTooltip from "react-tooltip";

import imgProcess from "../../../assets/img/img-process.svg";
import heartLine from "../../../assets/img/heart-line.svg";
import heartFill from "../../../assets/img/heart-fill.svg";
import Draggable from "react-draggable";
import { connect, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import actions from "../actions";
import { useSelector } from "react-redux";
import Iframe from "react-iframe";
import { Dropdown } from "react-bootstrap";
import noDataForAnalysis from "../../../assets/img/no-data-tr.svg";
import Loader from "../../common/components/Loader";
import LoadingOverlay from "react-loading-overlay";
import Actions from "../actions";
import ConfirmationModal from "../../common/components/ConfirmationModal";
import Portal from "../../common/components/Portal";
import { downloadPresignedUrlFile, getPresignedUrl } from "../../common/actions";
import InfiniteScroll from "react-infinite-scroll-component";
import { Cropper } from "react-cropper";
import "cropperjs/dist/cropper.css";
import CropperModal from "./CropperModal";
import { sanitizeHtml } from "../../common/components/SafeHtml";
import { ERROR_COPY } from "../../../config/errorMessages";

function ImageViewModal({
    selectedImg,
    onCancel,
    hasEdit,
    hasCaptionEdit = true,
    handleEdit,
    handleFavClick,
    viewRecommendations,
    entityPluralLabel = "Recommendations",
    entityLabel = "Recommendation",
    isAssignView,
    handleNext,
    handlePrev,
    imageList,
    updateImage,
    handleInputCaptionData,
    viewAssets,
    getImageAnalysisData,
    ImageParams,
    isSurveyAssetImage,
    updateImageFromSurveyAsset,
    isAssignedAssetImage,
    isMobileRegularRecom = false,
    isMobRecom = false,
    hasExport = false,
    // Replaces the AI Analyze tab's content when given. Only the AI Settings > Image Analyse page passes it
    // (Otto's saved findings); Image Management passes nothing and keeps the Rekognition tool unchanged.
    aiAnalyzeContent = null
}) {
    const [formattedAddress, setFormattedAddress] = useState("");
    const [caption, setCaption] = useState({
        caption: selectedImg?.caption,
        image_ids: [selectedImg?.id],
        tags: selectedImg?.labels?.map(item => item.name),
        removed_tags: [],
        captionchange: true
    });
    const [currentTab, setCurrentTab] = useState("main");
    const [toggleInput, setToggleInput] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [imageExporting, setImageExporting] = useState(false);
    const [imageAnalyzeLoader, setImageAnalyzeLoader] = useState(false);
    const [imageAnalyzeType, setImageAnalyzeType] = useState("");
    const [imageAnalyzeTab, setImageAnalyzeTab] = useState("text");
    const [originalText, setOriginalText] = useState([]);
    const [originalObjects, setOriginalObjects] = useState([]);
    const [editableItem, setEditableItem] = useState(false);
    const [confirmationModal, setConfirmationModal] = useState(false);
    const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
    const [savedData, setSavedData] = useState({ object: [], text: [] });
    const [copySuccessIndex, setCopySuccessIndex] = useState(false);
    const [params, setParams] = useState({ limit: 15, process_type: "", offset: 0, page: 1, search: "" });
    const { patchImageAnalysisData, getAnalyseResponse, getTotalAnalyseData } = useSelector(state => state.imageReducer);
    const [showErrorBorder, setShowErrorBorder] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [deleteAll, setDeleteAll] = useState(false);
    const [analyseUrl, setAnalyseUrl] = useState(null);
    const [isAnalysed, setIsAnalysed] = useState(false);
    const [cropperModal, setCropperModal] = useState(false);
    const [imageUrl, setImageUrl] = useState(null);
    const ref = useRef(null);
    const inputRef = useRef(null);
    const dispatch = useDispatch();

    useEffect(() => {
        let isMounted = true;
        const fetchAndCreateBlobUrl = async () => {
            const imageUrl = selectedImg?.is_edited ? selectedImg?.s3_eimage_key : selectedImg?.s3_image_key;

            if (!imageUrl) return;

            try {
                const response = await fetch(imageUrl);
                if (response.ok && isMounted) {
                    const blob = await response.blob();
                    const url = URL.createObjectURL(blob);
                    setImageUrl(url);
                }
            } catch (error) {
                console.error("Error fetching image:", error);
            }
        };

        fetchAndCreateBlobUrl();

        return () => {
            isMounted = false;
            if (imageUrl) {
                URL.revokeObjectURL(imageUrl);
            }
        };
    }, [selectedImg]);

    useEffect(() => {
        // The Rekognition data this effect loads is not shown when the tab renders Otto's findings instead.
        if (aiAnalyzeContent) return;
        if (!params?.offset) {
            dispatch(actions?.ClearPatchImageAnalysisData(true));
        }
        const currentState = imageAnalyzeTab === "text" ? originalText : originalObjects;
        if (currentState?.length !== (getAnalyseResponse?.total || 0) || !params?.offset) {
            dispatch(
                actions?.getAwsRekognition(
                    {
                        ...params,
                        process_type: imageAnalyzeTab,
                        img_type: "image_upload",
                        ...(isSurveyAssetImage && !isAssignedAssetImage && { type: "survey_image_upload" }),
                        ...(isMobRecom && { type: "image_upload" })
                    },
                    selectedImg?.id
                )
            );
        }
    }, [params, imageAnalyzeTab]);

    useEffect(() => {
        if (getAnalyseResponse?.success) {
            if (imageAnalyzeTab === "text") {
                setOriginalText(getAnalyseResponse?.results);
                setSavedData({ object: [], text: getAnalyseResponse?.results });
            } else {
                setOriginalObjects(getAnalyseResponse?.results);
                setSavedData({ object: getAnalyseResponse?.results, text: [] });
            }
        }
    }, [getAnalyseResponse]);
    useEffect(() => {
        const handleClickOutside = event => {
            if (inputRef.current && !inputRef.current.contains(event.target)) {
                setEditableItem(false);
                setOriginalObjects(savedData?.object);
                setOriginalText(savedData?.text);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [editableItem, inputRef]);

    useEffect(() => {
        !isSurveyAssetImage && ReactTooltip.rebuild();
        ReactTooltip.hide();
    }, [editableItem]);

    useEffect(() => {
        const { latitude = "", longitude = "" } = selectedImg?.meta_data ?? selectedImg ?? {};
        if (latitude && longitude) {
            setAddress(latitude, longitude);
        }
        !isSurveyAssetImage && ReactTooltip.rebuild();
        document.addEventListener("click", handleClickOutside, true);
        return () => {
            document.removeEventListener("click", handleClickOutside, true);
        };
    }, [toggleInput]);

    useEffect(() => {
        alertMessage?.length && showAlertMessages();
    }, [alertMessage]);

    useEffect(() => {
        if (imageAnalyzeType) {
            dispatch(actions?.ClearPatchImageAnalysisData(true));
            setOriginalText([]);
            analyzeImageData();
        }
    }, [imageAnalyzeType]);

    useEffect(() => {
        if (Object.keys(patchImageAnalysisData).length > 0 && !patchImageAnalysisData?.success && !cropperModal) {
            setAlertMessage(ERROR_COPY.GENERIC);
            if (imageAnalyzeTab === "text") setOriginalText(savedData?.text);
            else setOriginalObjects(savedData?.object);
        } else if (Object.keys(patchImageAnalysisData).length > 0 && patchImageAnalysisData && !cropperModal) {
            if (editableItem || editableItem === 0) {
                setAlertMessage("Image analyze data updated");
            } else {
                setAlertMessage("Deleted successfully");
            }
            setEditableItem(false);

            setSavedData({ ...savedData, [imageAnalyzeTab]: imageAnalyzeTab === "text" ? originalText : originalObjects });
            dispatch(Actions?.ClearPatchImageAnalysisData(false));
        }
    }, [patchImageAnalysisData?.success]);

    const handleScrollEnd = () => {
        setParams({ ...params, page: params?.page + 1, offset: params?.page * params?.limit });
        setEditableItem(false);
    };

    const handleClickOutside = event => {
        if (ref.current && !ref.current.contains(event.target)) {
            setToggleInput(false);
        }
    };

    const setAddress = async (latitude, longitude) => {
        let address = await getAddressFromCoordinates(latitude, longitude);
        setFormattedAddress(address);
    };

    const showAlert = () => showAlertUtil("Copied to Clipboard");

    const showAlertMessages = () => showAlertUtil(alertMessage, true);

    const handleClick = () => {
        if (hasCaptionEdit) setToggleInput(!toggleInput);
    };

    const handleInputCaption = async () => {
        await handleInputCaptionData(caption);
        handleClick();
        updateImageFromSurveyAsset ? updateImageFromSurveyAsset(caption) : updateImage(caption);
        ReactTooltip.rebuild();
    };

    const moveCaretAtEnd = e => {
        var temp_value = e.target.value;
        e.target.value = "";
        e.target.value = temp_value;
    };

    const downloadImage = async selectedImg => {
        setImageExporting(true);
        const fileName = `${selectedImg?.asset_uid ? `{${selectedImg.asset_uid}}` : ""}${selectedImg?.name}`;
        const publicUrl = selectedImg?.is_edited ? selectedImg?.s3_eimage_key : selectedImg?.s3_image_key;
        await downloadPresignedUrlFile(publicUrl, "attachment", fileName);
        setImageExporting(false);
    };

    const analyzeImageData = async () => {
        setImageAnalyzeLoader(true);
        await getImageAnalysisData({
            image_ids: [selectedImg?.id],
            text: imageAnalyzeType === "both" || imageAnalyzeType === "text" ? true : false,
            labels: imageAnalyzeType === "both" || imageAnalyzeType === "labels" ? true : false,
            type: isSurveyAssetImage && !isAssignedAssetImage ? "survey_image_upload" : isMobRecom ? "image_upload" : undefined
        });
        setImageAnalyzeType("");
        setParams({ ...params, page: 1, offset: 0, search: "" });
        setImageAnalyzeLoader(false);
    };

    const handleEditChange = (e, index, key) => {
        const { value } = e.target;
        setAlertMessage("");
        setShowErrorBorder(false);
        if (key === "text") {
            const updatedText = [...originalText];
            updatedText[index] = value;
            setOriginalText(updatedText);
        } else {
            const updatedText = [...originalObjects];
            updatedText[index] = value;
            setOriginalObjects(updatedText);
        }
    };

    const handleSaveChanges = (operationType, dataType) => {
        const dataToSend = {
            [selectedImg?.id]: {}
        };
        if (dataType === "save") {
            if (operationType === "text") {
                dataToSend[selectedImg?.id].text = { [savedData?.text?.[editableItem]]: originalText?.[editableItem] };
                const cleanedArray = originalText.filter(item => item !== "");
                setOriginalText(cleanedArray);
            } else if (operationType === "labels") {
                dataToSend[selectedImg?.id].labels = { [savedData?.object?.[editableItem]]: originalObjects?.[editableItem] };
                const cleanedArray = originalObjects.filter(item => item !== "");
                setOriginalObjects(cleanedArray);
            }
        } else if (dataType === "deleteAll") {
            if (operationType === "labels") {
                setOriginalObjects([]);
                dataToSend[selectedImg.id].labels = [];
            } else if (operationType === "text") {
                setOriginalText([]);
                dataToSend[selectedImg.id].text = [];
            }
        } else if (dataType === "delete") {
            if (operationType === "labels") {
                setOriginalObjects(prevState => {
                    const updatedText = prevState.filter((_, i) => i !== showDeleteConfirmModal);
                    dataToSend[selectedImg?.id].labels = { [prevState?.[showDeleteConfirmModal]]: "" };
                    return updatedText;
                });
            } else if (operationType === "text") {
                setOriginalText(prevState => {
                    const updatedText = prevState.filter((_, i) => i !== showDeleteConfirmModal);
                    dataToSend[selectedImg.id].text = { [prevState?.[showDeleteConfirmModal]]: "" };
                    return updatedText;
                });
            }
        }
        let paramData = { ...dataToSend };
        if (isSurveyAssetImage && !isAssignedAssetImage) paramData = { ...paramData, type: "survey_image_upload" };
        if (isMobRecom) paramData = { ...paramData, type: "image_upload" };
        const currentData = imageAnalyzeTab === "text" ? originalText?.[editableItem] : originalObjects?.[editableItem];
        if (
            getTotalAnalyseData?.results?.map(item => item?.trim()?.toLowerCase())?.includes(currentData?.trim()?.toLowerCase()) &&
            dataType === "save"
        ) {
            setShowErrorBorder(true);
            setAlertMessage("Already exist");
        } else {
            dispatch(Actions?.patchImageAnalysisData({ ...paramData }, ImageParams));
            setAlertMessage("");
            setShowErrorBorder(false);
        }
    };
    const renderMenuSwitchConfirmationModal = () => {
        if (!confirmationModal && !analyseUrl) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={analyseUrl ? "Do you want to analyze the image" : "Performing a new analysis will overwrite all existing data"}
                        message={!analyseUrl && "Are you sure you want to conduct another analysis?"}
                        onNo={() => {
                            setConfirmationModal(false);
                            setAnalyseUrl(null);
                            // setIsAnalysed(false);
                        }}
                        onYes={() => {
                            if (analyseUrl) {
                                const formData = new FormData();
                                formData.append("process_type", cropperModal);
                                formData.append("img_type", "img_type");
                                formData.append("type", isSurveyAssetImage && !isAssignedAssetImage ? "survey_image_upload" : "image_upload");
                                formData.append("image_id", selectedImg?.id);
                                formData.append("image", analyseUrl);
                                dispatch(actions?.getRawImageAnalysisData(formData, selectedImg?.id, false, true));
                                setIsAnalysed(analyseUrl);
                                setAnalyseUrl(null);
                            } else {
                                const tabType = confirmationModal === "text" ? "text" : confirmationModal === "labels" ? "labels" : "both";
                                setImageAnalyzeTab(tabType === "both" ? "text" : tabType);
                                setImageAnalyzeType(tabType);
                                setParams({ ...params, offset: 0, page: 1, search: "" });
                                setConfirmationModal(false);
                            }
                        }}
                    />
                }
                onCancel={() => {
                    setConfirmationModal(false);
                    setAnalyseUrl(null);
                    setIsAnalysed(false);
                }}
            />
        );
    };

    const handleInputChange = event => {
        const value = event.target.value;
        setParams({ ...params, offset: 0, page: 1, search: value });
    };
    const renderConfirmationModal = () => {
        if (showDeleteConfirmModal === false && !deleteAll) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={`Do you want to delete ${deleteAll ? "all" : "this text"}?`}
                        message={`This action cannot be reverted, are you sure that you need to delete ${!deleteAll ? "this item" : ""}?`}
                        onNo={() => {
                            setShowDeleteConfirmModal(false);
                            setDeleteAll(false);
                        }}
                        onYes={() => {
                            handleSaveChanges(imageAnalyzeTab, deleteAll ? "deleteAll" : "delete");
                            setShowDeleteConfirmModal(false);
                            setDeleteAll(false);
                        }}
                    />
                }
                onCancel={() => {
                    setShowDeleteConfirmModal(false);
                    setDeleteAll(false);
                }}
            />
        );
    };
    const isEditDisabled =
        savedData?.[imageAnalyzeTab]?.[editableItem]?.toLowerCase() ===
        (imageAnalyzeTab === "text" ? originalText?.[editableItem]?.trim()?.toLowerCase() : originalObjects?.[editableItem]?.trim()?.toLowerCase());

    const renderCropperModal = () => {
        if (!cropperModal) return null;
        return (
            <Portal
                body={
                    <CropperModal
                        selectedImg={imageUrl}
                        onCancel={() => {
                            setCropperModal(false);
                            setAnalyseUrl(false);
                            setIsAnalysed(false);
                            setParams({ ...params, offset: 0, page: 1, search: "" });
                        }}
                        analyseClick={(url, isAnalyseAgain = false) => {
                            if (isAnalyseAgain) {
                                const formData = new FormData();
                                formData.append("process_type", cropperModal);
                                formData.append("img_type", "img_type");
                                formData.append("type", isSurveyAssetImage && !isAssignedAssetImage ? "survey_image_upload" : "image_upload");
                                formData.append("image_id", selectedImg?.id);
                                formData.append("image", url);
                                dispatch(actions?.getRawImageAnalysisData(formData, selectedImg?.id, false, true));
                                setIsAnalysed(url);
                                setAnalyseUrl(null);
                            } else {
                                setAnalyseUrl(url);
                            }
                        }}
                        isSurveyAssetImage={isSurveyAssetImage && !isAssignedAssetImage}
                        selectedImgId={selectedImg?.id}
                        analyseKey={cropperModal}
                        isAnalysed={isAnalysed}
                        setIsAnalysed={setIsAnalysed}
                    />
                }
                onCancel={() => {
                    setCropperModal(false);
                    setIsAnalysed(false);
                }}
            />
        );
    };

    const width = selectedImg?.meta_data?.width ?? selectedImg?.width;
    const height = selectedImg?.meta_data?.height ?? selectedImg?.height;
    return (
        <div id="modalId" className="modal modal-region modal-img-magamnt modal-editable-view" ref={ref} style={{ display: "block", cursor: "move" }}>
            <Draggable cancel=".not-dragabble">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div>
                            <button
                                type="button"
                                className={`arrow-butn-left ${selectedImg?.id === imageList[0]?.id ? "cursor-disabled" : ""}`}
                                disabled={selectedImg?.id === imageList[0]?.id}
                                onClick={() => handlePrev(selectedImg?.id)}
                                data-place="top"
                                data-effect="solid"
                                data-tip="Previous"
                                data-for={`${selectedImg.id}-view`}
                            >
                                <i class="fas fa-chevron-left"></i>
                            </button>
                            <button
                                type="button"
                                className={`arrow-butn-right ${selectedImg?.id === imageList[imageList.length - 1]?.id ? "cursor-disabled" : ""}`}
                                disabled={selectedImg?.id === imageList[imageList.length - 1]?.id}
                                onClick={() => handleNext(selectedImg.id)}
                                data-place="top"
                                data-effect="solid"
                                data-tip="Next"
                                data-for={`${selectedImg.id}-view`}
                            >
                                <i class="fas fa-chevron-right"></i>
                            </button>
                        </div>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onCancel}>
                            <span aria-hidden="true">
                                <img src="/img/close.svg" alt="" />
                            </span>
                        </button>
                        <div className="modal-header">
                            <div class="heading position-relative">
                                {toggleInput ? (
                                    <label className="not-dragabble" htmlFor="">
                                        <>
                                            <div>
                                                <textarea
                                                    className="floating-textarea img-txt-area not-draggable"
                                                    type="text"
                                                    value={caption.caption}
                                                    onChange={e => {
                                                        resetCursor(e);
                                                        let updatedValue = {};
                                                        updatedValue = { caption: toTitleCase(e.target.value) };
                                                        setCaption(caption => ({ ...caption, ...updatedValue }));
                                                    }}
                                                    onBlur={() => setToggleInput(false)}
                                                    onKeyPress={event => {
                                                        if (event.key === "Enter") {
                                                            handleInputCaption();
                                                        }
                                                    }}
                                                    autoFocus
                                                    onFocus={moveCaretAtEnd}
                                                    placeholder="Caption"
                                                    onDoubleClick={handleClick}
                                                    data-place="bottom"
                                                    data-effect="solid"
                                                    data-for={`${selectedImg.id}-view`}
                                                    data-tip={
                                                        "<b>Please Click Enter key to Update</b><br/>.........................Or........................<br/><b>Double Click  to Go Back</b> <br/>"
                                                    }
                                                />
                                            </div>
                                        </>
                                    </label>
                                ) : (
                                    <h5
                                        data-place="top"
                                        data-effect="solid"
                                        data-tip={
                                            hasCaptionEdit
                                                ? selectedImg?.caption
                                                    ? `<b>Double Click Here to Edit Caption</b> <br/> ${selectedImg?.caption}`
                                                    : "Double Click Here to Add Caption"
                                                : ""
                                        }
                                        data-for={`${selectedImg.id}-view`}
                                        style={{ cursor: "pointer" }}
                                        className="not-dragabble"
                                        onDoubleClick={handleClick}
                                    >
                                        {selectedImg?.caption || "-"}
                                    </h5>
                                )}
                                <div class="image-right d-flex">
                                    {!isSurveyAssetImage && !isMobRecom && (
                                        <div class="mr-2">
                                            <span class="icon-url icon-heart">
                                                <img
                                                    src={selectedImg?.favourite ? heartFill : heartLine}
                                                    data-for={`${selectedImg.id}-view`}
                                                    data-tip={selectedImg?.favourite ? "Remove from Favorites" : "Add to Favorites"}
                                                    onClick={() => handleFavClick(selectedImg.id, !selectedImg.favourite)}
                                                    alt=""
                                                />
                                            </span>
                                        </div>
                                    )}
                                    {hasEdit && getFileExtension(selectedImg.s3_image_key) !== "html" && (
                                        <div class="mr-2">
                                            <i
                                                class="fa fa-edit"
                                                onClick={() => handleEdit(selectedImg)}
                                                data-for={`${selectedImg.id}-view`}
                                                data-tip="Edit Image"
                                            ></i>
                                        </div>
                                    )}
                                    {/* <div class="mr-2">
                                        <CopyToClipboard
                                            // text={selectedImg?.s3_image_key}
                                            text={selectedImg?.is_edited ? `${selectedImg?.s3_eimage_key}` : `${selectedImg?.s3_image_key}`}
                                            onCopy={() => {
                                                setCopied(true);
                                                setTimeout(() => {
                                                    setCopied(false);
                                                }, 3500);
                                            }}
                                        >
                                            {copied ? (
                                                <i
                                                    class="fa fa-check"
                                                    style={{ color: "green" }}
                                                    data-for={`${selectedImg.id}-view`}
                                                    data-tip={"Copied to Clipboard"}
                                                ></i>
                                            ) : (
                                                <i
                                                    class="fa fa-link"
                                                    onClick={() => showAlert()}
                                                    data-for={`${selectedImg.id}-view`}
                                                    data-tip={"Click to Copy Image URL"}
                                                ></i>
                                            )}
                                        </CopyToClipboard>
                                    </div> */}
                                    {hasExport && (
                                        <div class="mr-2">
                                            {imageExporting ? (
                                                <div className="edit-icn-bx icon-btn-sec d-inline-block">
                                                    <div className="spinner-border" role="status"></div>
                                                </div>
                                            ) : (
                                                <i
                                                    class="fa fa-download"
                                                    onClick={() => downloadImage(selectedImg)}
                                                    data-for={`${selectedImg.id}-view`}
                                                    data-tip="Download Image"
                                                ></i>
                                            )}
                                        </div>
                                    )}
                                    {!isAssignView && selectedImg?.recommendations?.length ? (
                                        <div
                                            class="icon mr-2 cursor-hand"
                                            onClick={() => viewRecommendations(selectedImg)}
                                            data-for={`${selectedImg.id}-view`}
                                            data-tip={`View Assigned ${entityPluralLabel}`}
                                        >
                                            <img src={docIcon} height={18} width={18} alt="" />
                                        </div>
                                    ) : null}
                                    {!isAssignView && selectedImg?.assets?.length ? (
                                        <div
                                            class="icon mr-2 cursor-hand"
                                            onClick={() => viewAssets(selectedImg)}
                                            data-for={`${selectedImg.id}-view`}
                                            data-tip="View Assigned Assets"
                                        >
                                            <img src={docIcon} height={18} width={18} alt="" />
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        <div className="modal-body region-otr">
                            {selectedImg?.s3_image_key ? (
                                <>
                                    {getFileExtension(selectedImg.s3_image_key) === "html" ? (
                                        <div className="image-preview not-dragabble">
                                            <Iframe
                                                url={selectedImg?.s3_image_key}
                                                width="100%"
                                                height="100%"
                                                display="initial"
                                                position="relative"
                                                className="pdf-view"
                                                overflow="hidden"
                                            />
                                        </div>
                                    ) : (
                                        <TransformWrapper defaultScale={1}>
                                            {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                                                <div className="image-preview not-dragabble">
                                                    <div className="md-grp-btn">
                                                        <button type="button" onClick={zoomIn}>
                                                            <img src="/img/zoom-in.svg" alt="" />
                                                        </button>
                                                        <button type="button" onClick={zoomOut}>
                                                            <img src="/img/zoom-out.svg" alt="" />
                                                        </button>
                                                    </div>
                                                    <TransformComponent>
                                                        <LazyLoadImage
                                                            effect="blur"
                                                            // src={`${selectedImg?.s3_image_key}?${moment(selectedImg?.updated_at).format()}`}
                                                            src={selectedImg?.is_edited ? selectedImg?.s3_eimage_key : selectedImg?.s3_image_key}
                                                        />
                                                    </TransformComponent>
                                                </div>
                                            )}
                                        </TransformWrapper>
                                    )}
                                </>
                            ) : (
                                <div className="image-preview">
                                    <div class="img-process">
                                        <img src={imgProcess} alt="" />
                                        <h3>Processing...</h3>
                                    </div>
                                </div>
                            )}
                            <div className="cnt-img-se outer-right-tabpane not-dragabble">
                                <ul className="nav-ul-tab">
                                    <li
                                        className={currentTab === "main" ? "active cursor-hand" : "cursor-hand"}
                                        onClick={() => setCurrentTab("main")}
                                    >
                                        Main Details
                                    </li>
                                    <li
                                        className={currentTab === "meta" ? "active cursor-hand" : "cursor-hand"}
                                        onClick={() => setCurrentTab("meta")}
                                    >
                                        Meta Data
                                    </li>
                                    {!isSurveyAssetImage && !isMobRecom && (
                                        <li
                                            className={currentTab === "labels" ? "active cursor-hand" : "cursor-hand"}
                                            onClick={() => setCurrentTab("labels")}
                                        >
                                            Labels
                                        </li>
                                    )}
                                    {!isMobileRegularRecom && (
                                        <li
                                            className={currentTab === "image_text" ? "active cursor-hand" : "cursor-hand"}
                                            onClick={() => setCurrentTab("image_text")}
                                        >
                                            AI Analyze
                                        </li>
                                    )}
                                </ul>
                                {currentTab === "main" ? (
                                    <>
                                        <div className="img-itms">
                                            <div className="icons">
                                                <img src={buildingIcon} alt="" />
                                            </div>

                                            <div className="text-area">
                                                <h4>Client</h4>
                                                <h3>{selectedImg?.client?.name || "-"}</h3>
                                            </div>
                                        </div>
                                        <div className="img-itms">
                                            <div className="icons">
                                                <img src={buildingIcon} alt="" />
                                            </div>
                                            <div className="text-area">
                                                <h4>Project</h4>
                                                <h3>{selectedImg?.project?.name || "-"}</h3>
                                            </div>
                                        </div>
                                        <div className="img-itms">
                                            <div className="icons">
                                                <img src={buildingIcon} alt="" />
                                            </div>
                                            <div className="text-area">
                                                <h4>Region</h4>
                                                <h3>{selectedImg?.region?.name || "-"}</h3>
                                            </div>
                                        </div>
                                        <div className="img-itms">
                                            <div className="icons">
                                                <img src={buildingIcon} alt="" />
                                            </div>
                                            <div className="text-area">
                                                <h4>Site</h4>
                                                <h3>{selectedImg?.site?.name || "-"}</h3>
                                            </div>
                                        </div>
                                        <div className="img-itms">
                                            <div className="icons">
                                                <img src={buildingIcon} alt="" />
                                            </div>
                                            <div className="text-area">
                                                <h4>Building</h4>
                                                <h3>
                                                    {`${selectedImg?.building?.name || "-"} ${
                                                        selectedImg?.building?.description ? `(${selectedImg?.building?.description})` : ""
                                                    }` || ""}
                                                </h3>
                                            </div>
                                        </div>
                                        <div className="img-itms">
                                            <div className="icons">
                                                <img src={tradeIcon} alt="" />
                                            </div>
                                            <div className="text-area">
                                                <h4>Trade</h4>
                                                <h3>{selectedImg?.trade?.name || "-"}</h3>
                                            </div>
                                        </div>
                                        <div className="img-itms">
                                            <div className="icons">
                                                <img src={systemIcon} alt="" />
                                            </div>
                                            <div className="text-area">
                                                <h4>System</h4>
                                                <h3>{selectedImg?.system?.name || "-"}</h3>
                                            </div>
                                        </div>
                                        <div className="img-itms">
                                            <div className="icons">
                                                <img src={subSystemIcon} alt="" />
                                            </div>
                                            <div className="text-area">
                                                <h4>Sub-System</h4>
                                                <h3>{selectedImg?.sub_system?.name || "-"}</h3>
                                            </div>
                                        </div>
                                    </>
                                ) : currentTab === "meta" ? (
                                    <div className="img-itms meta not-dragabble">
                                        <div className="foot-area">
                                            <div class="list">
                                                <span class="label-nme">File Name </span>
                                                <span>: </span>
                                                <span class="dtl-lbl">{`${selectedImg?.asset_uid ? `{${selectedImg?.asset_uid}}` : ""}${
                                                    selectedImg?.name
                                                }`}</span>
                                            </div>
                                            <div className="list">
                                                <span class="label-nme">Uploaded By </span>
                                                <span>: </span>
                                                <span class="dtl-lbl">{selectedImg?.user?.name}</span>
                                            </div>
                                            {(selectedImg?.meta_data?.date_taken ?? selectedImg?.date_taken) && (
                                                <div className="list">
                                                    <span class="label-nme">Date Taken </span>
                                                    <span>: </span>{" "}
                                                    <span class="dtl-lbl">
                                                        {moment(selectedImg?.meta_data?.date_taken ?? selectedImg?.date_taken).format(
                                                            "dddd, MMMM Do YYYY, h:mm a"
                                                        ) || ""}
                                                    </span>
                                                </div>
                                            )}
                                            <div className="list">
                                                <span class="label-nme">Date Uploaded </span>
                                                <span>: </span>
                                                <span class="dtl-lbl">
                                                    {selectedImg?.created_at ?? selectedImg?.created_date
                                                        ? moment(selectedImg?.created_at ?? selectedImg?.created_date).format(
                                                              "dddd, MMMM Do YYYY, h:mm a"
                                                          ) || "-"
                                                        : "-"}
                                                </span>
                                            </div>
                                            <div className="list">
                                                <span class="label-nme">Date Modified</span>
                                                <span>: </span>
                                                <span class="dtl-lbl">
                                                    {selectedImg?.updated_at ?? selectedImg?.modified_date
                                                        ? moment(selectedImg?.updated_at ?? selectedImg?.modified_date).format(
                                                              "dddd, MMMM Do YYYY, h:mm a"
                                                          ) || "-"
                                                        : "-"}
                                                </span>
                                            </div>
                                            <div className="list">
                                                <span class="label-nme">Image Modified</span>
                                                <span>: </span>
                                                <span class="dtl-lbl">{selectedImg?.is_edited === true ? "Yes" : "No"}</span>
                                            </div>

                                            {formattedAddress && (
                                                <div className="list">
                                                    <span class="label-nme">Location </span>
                                                    <span>: </span>
                                                    <span class="dtl-lbl">{formattedAddress}</span>
                                                </div>
                                            )}
                                            {(selectedImg?.meta_data?.file_size || selectedImg?.file_size) && (
                                                <div className="list">
                                                    <span class="label-nme">Size </span>
                                                    <span>: </span>
                                                    <span class="dtl-lbl">
                                                        {renderFileSize(selectedImg?.meta_data?.file_size ?? selectedImg?.file_size) || ""}
                                                    </span>
                                                </div>
                                            )}
                                            <div class="list">
                                                <span class="label-nme">Is Asset Image</span>
                                                <span>: </span>
                                                <span class="dtl-lbl">{selectedImg?.is_asset_image ? "Yes" : "No"}</span>
                                            </div>
                                            <div className="list">
                                                <span className="label-nme">Resolution</span>
                                                <span>: </span>
                                                <span className="dtl-lbl">{width && height ? `${width} x ${height}` : "-"}</span>
                                            </div>
                                            <div class="list">
                                                <span class="label-nme">Source</span>
                                                <span>: </span>
                                                <span class="dtl-lbl">{selectedImg?.source ? selectedImg?.source : "-"}</span>
                                            </div>
                                        </div>
                                    </div>
                                ) : currentTab === "image_text" && aiAnalyzeContent ? (
                                    aiAnalyzeContent
                                ) : currentTab === "image_text" ? (
                                    <LoadingOverlay
                                        active={imageAnalyzeLoader || (getAnalyseResponse?.loading && !getAnalyseResponse?.total)}
                                        spinner={<Loader />}
                                        fadeSpeed={10}
                                    >
                                        <div className="img-itms meta not-dragabble">
                                            <div className="img-txt-label-outer">
                                                <ul className="list-sec-buton">
                                                    <div class="d-flex btn-tx-obj">
                                                        <li
                                                            className={`list-btn ${imageAnalyzeTab === "text" ? "list-btn-active" : ""}`}
                                                            onClick={() => {
                                                                setImageAnalyzeTab("text");
                                                                setParams({ ...params, offset: 0, page: 1, search: "" });
                                                            }}
                                                        >
                                                            <svg
                                                                id="text-38"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="15.391"
                                                                height="15.391"
                                                                viewBox="0 0 15.391 15.391"
                                                            >
                                                                <path
                                                                    id="Path_218"
                                                                    data-name="Path 218"
                                                                    d="M12.826,15.391H2.565A2.573,2.573,0,0,1,0,12.826V2.565A2.573,2.573,0,0,1,2.565,0H12.826a2.573,2.573,0,0,1,2.565,2.565V12.826A2.573,2.573,0,0,1,12.826,15.391ZM2.565,1.283A1.286,1.286,0,0,0,1.283,2.565V12.826a1.286,1.286,0,0,0,1.283,1.283H12.826a1.286,1.286,0,0,0,1.283-1.283V2.565a1.286,1.286,0,0,0-1.283-1.283Z"
                                                                    fill="#7489a1"
                                                                ></path>
                                                                <path
                                                                    id="Path_219"
                                                                    data-name="Path 219"
                                                                    d="M263.054,257.283h-6.413a.641.641,0,1,1,0-1.283h6.413a.641.641,0,1,1,0,1.283Z"
                                                                    transform="translate(-252.152 -252.153)"
                                                                    fill="#7489a1"
                                                                ></path>
                                                                <path
                                                                    id="Path_220"
                                                                    data-name="Path 220"
                                                                    d="M256.641,257.924a.606.606,0,0,1-.641-.641v-.641a.641.641,0,0,1,1.283,0v.641A.606.606,0,0,1,256.641,257.924Z"
                                                                    transform="translate(-252.152 -252.153)"
                                                                    fill="#7489a1"
                                                                ></path>
                                                                <path
                                                                    id="Path_221"
                                                                    data-name="Path 221"
                                                                    d="M683.308,257.924a.606.606,0,0,1-.641-.641v-.641a.641.641,0,1,1,1.283,0v.641A.606.606,0,0,1,683.308,257.924Z"
                                                                    transform="translate(-672.406 -252.153)"
                                                                    fill="#7489a1"
                                                                ></path>
                                                                <path
                                                                    id="Path_222"
                                                                    data-name="Path 222"
                                                                    d="M469.974,263.7a.606.606,0,0,1-.641-.641v-6.413a.641.641,0,0,1,1.283,0v6.413A.606.606,0,0,1,469.974,263.7Z"
                                                                    transform="translate(-462.279 -252.153)"
                                                                    fill="#7489a1"
                                                                ></path>
                                                                <path
                                                                    id="Path_223"
                                                                    data-name="Path 223"
                                                                    d="M428.591,683.949h-1.283a.641.641,0,0,1,0-1.283h1.283a.641.641,0,1,1,0,1.283Z"
                                                                    transform="translate(-420.254 -672.406)"
                                                                    fill="#7489a1"
                                                                ></path>
                                                            </svg>
                                                            Text
                                                        </li>
                                                        <li
                                                            className={`list-btn ${imageAnalyzeTab === "labels" ? "list-btn-active" : ""}`}
                                                            onClick={() => {
                                                                setImageAnalyzeTab("labels");
                                                                setParams({ ...params, offset: 0, page: 1, search: "" });
                                                            }}
                                                        >
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="17.196"
                                                                height="17.196"
                                                                viewBox="0 0 17.196 17.196"
                                                            >
                                                                <path
                                                                    id="object-group-svgrepo-com"
                                                                    d="M18.336,16.014V5.181A1.664,1.664,0,0,0,19.2,3.72,1.725,1.725,0,0,0,17.476,2a1.664,1.664,0,0,0-1.462.86H5.181A1.664,1.664,0,0,0,3.72,2,1.725,1.725,0,0,0,2,3.72a1.664,1.664,0,0,0,.86,1.462V16.014A1.664,1.664,0,0,0,2,17.476,1.725,1.725,0,0,0,3.72,19.2a1.664,1.664,0,0,0,1.462-.86H16.014a1.664,1.664,0,0,0,1.462.86,1.725,1.725,0,0,0,1.72-1.72A1.664,1.664,0,0,0,18.336,16.014Zm-1.72,0a2.009,2.009,0,0,0-.6.6H5.181a2.009,2.009,0,0,0-.6-.6V5.181a2.009,2.009,0,0,0,.6-.6H16.014a2.009,2.009,0,0,0,.6.6Zm-4.3-8v-.86a.812.812,0,0,0-.86-.86h-4.3a.812.812,0,0,0-.86.86v4.3a.812.812,0,0,0,.86.86h.86V9.738a1.725,1.725,0,0,1,1.72-1.72Zm1.72.86h-4.3a.812.812,0,0,0-.86.86v4.3a.812.812,0,0,0,.86.86h4.3a.812.812,0,0,0,.86-.86v-4.3A.812.812,0,0,0,14.037,8.878Z"
                                                                    transform="translate(-2 -2)"
                                                                    fill="#7489a1"
                                                                ></path>
                                                            </svg>
                                                            Object
                                                        </li>
                                                    </div>
                                                    <li class="list-btn anal-btn-outer">
                                                        <div class="analise-butn">
                                                            <Dropdown>
                                                                <Dropdown.Toggle id="dropdown-basic">
                                                                    <span className="">Analyze</span>
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item
                                                                        onClick={() => {
                                                                            if (originalText?.length > 0) {
                                                                                setConfirmationModal("text");
                                                                            } else {
                                                                                setImageAnalyzeTab("text");
                                                                                setImageAnalyzeType("text");
                                                                            }
                                                                            setEditableItem(false);
                                                                        }}
                                                                    >
                                                                        <svg
                                                                            id="text-38"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="15.391"
                                                                            height="15.391"
                                                                            viewBox="0 0 15.391 15.391"
                                                                        >
                                                                            <path
                                                                                id="Path_218"
                                                                                data-name="Path 218"
                                                                                d="M12.826,15.391H2.565A2.573,2.573,0,0,1,0,12.826V2.565A2.573,2.573,0,0,1,2.565,0H12.826a2.573,2.573,0,0,1,2.565,2.565V12.826A2.573,2.573,0,0,1,12.826,15.391ZM2.565,1.283A1.286,1.286,0,0,0,1.283,2.565V12.826a1.286,1.286,0,0,0,1.283,1.283H12.826a1.286,1.286,0,0,0,1.283-1.283V2.565a1.286,1.286,0,0,0-1.283-1.283Z"
                                                                                fill="#7489a1"
                                                                            />
                                                                            <path
                                                                                id="Path_219"
                                                                                data-name="Path 219"
                                                                                d="M263.054,257.283h-6.413a.641.641,0,1,1,0-1.283h6.413a.641.641,0,1,1,0,1.283Z"
                                                                                transform="translate(-252.152 -252.153)"
                                                                                fill="#7489a1"
                                                                            />
                                                                            <path
                                                                                id="Path_220"
                                                                                data-name="Path 220"
                                                                                d="M256.641,257.924a.606.606,0,0,1-.641-.641v-.641a.641.641,0,0,1,1.283,0v.641A.606.606,0,0,1,256.641,257.924Z"
                                                                                transform="translate(-252.152 -252.153)"
                                                                                fill="#7489a1"
                                                                            />
                                                                            <path
                                                                                id="Path_221"
                                                                                data-name="Path 221"
                                                                                d="M683.308,257.924a.606.606,0,0,1-.641-.641v-.641a.641.641,0,1,1,1.283,0v.641A.606.606,0,0,1,683.308,257.924Z"
                                                                                transform="translate(-672.406 -252.153)"
                                                                                fill="#7489a1"
                                                                            />
                                                                            <path
                                                                                id="Path_222"
                                                                                data-name="Path 222"
                                                                                d="M469.974,263.7a.606.606,0,0,1-.641-.641v-6.413a.641.641,0,0,1,1.283,0v6.413A.606.606,0,0,1,469.974,263.7Z"
                                                                                transform="translate(-462.279 -252.153)"
                                                                                fill="#7489a1"
                                                                            />
                                                                            <path
                                                                                id="Path_223"
                                                                                data-name="Path 223"
                                                                                d="M428.591,683.949h-1.283a.641.641,0,0,1,0-1.283h1.283a.641.641,0,1,1,0,1.283Z"
                                                                                transform="translate(-420.254 -672.406)"
                                                                                fill="#7489a1"
                                                                            />
                                                                        </svg>
                                                                        Text
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item
                                                                        onClick={() => {
                                                                            if (originalObjects?.length > 0) {
                                                                                setConfirmationModal("labels");
                                                                            } else {
                                                                                setImageAnalyzeTab("labels");
                                                                                setImageAnalyzeType("labels");
                                                                            }
                                                                            setEditableItem(false);
                                                                        }}
                                                                    >
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="17.196"
                                                                            height="17.196"
                                                                            viewBox="0 0 17.196 17.196"
                                                                        >
                                                                            <path
                                                                                id="object-group-svgrepo-com"
                                                                                d="M18.336,16.014V5.181A1.664,1.664,0,0,0,19.2,3.72,1.725,1.725,0,0,0,17.476,2a1.664,1.664,0,0,0-1.462.86H5.181A1.664,1.664,0,0,0,3.72,2,1.725,1.725,0,0,0,2,3.72a1.664,1.664,0,0,0,.86,1.462V16.014A1.664,1.664,0,0,0,2,17.476,1.725,1.725,0,0,0,3.72,19.2a1.664,1.664,0,0,0,1.462-.86H16.014a1.664,1.664,0,0,0,1.462.86,1.725,1.725,0,0,0,1.72-1.72A1.664,1.664,0,0,0,18.336,16.014Zm-1.72,0a2.009,2.009,0,0,0-.6.6H5.181a2.009,2.009,0,0,0-.6-.6V5.181a2.009,2.009,0,0,0,.6-.6H16.014a2.009,2.009,0,0,0,.6.6Zm-4.3-8v-.86a.812.812,0,0,0-.86-.86h-4.3a.812.812,0,0,0-.86.86v4.3a.812.812,0,0,0,.86.86h.86V9.738a1.725,1.725,0,0,1,1.72-1.72Zm1.72.86h-4.3a.812.812,0,0,0-.86.86v4.3a.812.812,0,0,0,.86.86h4.3a.812.812,0,0,0,.86-.86v-4.3A.812.812,0,0,0,14.037,8.878Z"
                                                                                transform="translate(-2 -2)"
                                                                                fill="#7489a1"
                                                                            />
                                                                        </svg>
                                                                        Object
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item
                                                                        onClick={() => {
                                                                            if (originalObjects?.length > 0 || originalText?.length > 0) {
                                                                                setConfirmationModal("both");
                                                                            } else {
                                                                                setImageAnalyzeTab("text");
                                                                                setImageAnalyzeType("both");
                                                                            }
                                                                            setEditableItem(false);
                                                                        }}
                                                                    >
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="15.391"
                                                                            height="15.391"
                                                                            viewBox="0 0 15.391 15.391"
                                                                        >
                                                                            <g
                                                                                id="Group_18697"
                                                                                data-name="Group 18697"
                                                                                transform="translate(-600 -572.804)"
                                                                            >
                                                                                <g id="text-38" transform="translate(600 572.804)">
                                                                                    <path
                                                                                        id="Path_218"
                                                                                        data-name="Path 218"
                                                                                        d="M12.826,15.391H2.565A2.573,2.573,0,0,1,0,12.826V2.565A2.573,2.573,0,0,1,2.565,0H12.826a2.573,2.573,0,0,1,2.565,2.565V12.826A2.573,2.573,0,0,1,12.826,15.391ZM2.565,1.283A1.286,1.286,0,0,0,1.283,2.565V12.826a1.286,1.286,0,0,0,1.283,1.283H12.826a1.286,1.286,0,0,0,1.283-1.283V2.565a1.286,1.286,0,0,0-1.283-1.283Z"
                                                                                        fill="#7489a1"
                                                                                    />
                                                                                </g>
                                                                                <path
                                                                                    id="Sort_both_small"
                                                                                    d="M0,4.122,4.122,0,8.245,4.122ZM0,5.153,4.122,9.275,8.245,5.153Z"
                                                                                    transform="translate(612.333 576.378) rotate(90)"
                                                                                    fill="#7489a1"
                                                                                />
                                                                            </g>
                                                                        </svg>
                                                                        Both
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item
                                                                        onClick={() => {
                                                                            setCropperModal("text");
                                                                            setImageAnalyzeTab("text");
                                                                        }}
                                                                    >
                                                                        <svg
                                                                            id="text-38"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="15.391"
                                                                            height="15.391"
                                                                            viewBox="0 0 15.391 15.391"
                                                                        >
                                                                            <path
                                                                                id="Path_218"
                                                                                data-name="Path 218"
                                                                                d="M12.826,15.391H2.565A2.573,2.573,0,0,1,0,12.826V2.565A2.573,2.573,0,0,1,2.565,0H12.826a2.573,2.573,0,0,1,2.565,2.565V12.826A2.573,2.573,0,0,1,12.826,15.391ZM2.565,1.283A1.286,1.286,0,0,0,1.283,2.565V12.826a1.286,1.286,0,0,0,1.283,1.283H12.826a1.286,1.286,0,0,0,1.283-1.283V2.565a1.286,1.286,0,0,0-1.283-1.283Z"
                                                                                fill="#7489a1"
                                                                            />
                                                                            <path
                                                                                id="Path_219"
                                                                                data-name="Path 219"
                                                                                d="M263.054,257.283h-6.413a.641.641,0,1,1,0-1.283h6.413a.641.641,0,1,1,0,1.283Z"
                                                                                transform="translate(-252.152 -252.153)"
                                                                                fill="#7489a1"
                                                                            />
                                                                            <path
                                                                                id="Path_220"
                                                                                data-name="Path 220"
                                                                                d="M256.641,257.924a.606.606,0,0,1-.641-.641v-.641a.641.641,0,0,1,1.283,0v.641A.606.606,0,0,1,256.641,257.924Z"
                                                                                transform="translate(-252.152 -252.153)"
                                                                                fill="#7489a1"
                                                                            />
                                                                            <path
                                                                                id="Path_221"
                                                                                data-name="Path 221"
                                                                                d="M683.308,257.924a.606.606,0,0,1-.641-.641v-.641a.641.641,0,1,1,1.283,0v.641A.606.606,0,0,1,683.308,257.924Z"
                                                                                transform="translate(-672.406 -252.153)"
                                                                                fill="#7489a1"
                                                                            />
                                                                            <path
                                                                                id="Path_222"
                                                                                data-name="Path 222"
                                                                                d="M469.974,263.7a.606.606,0,0,1-.641-.641v-6.413a.641.641,0,0,1,1.283,0v6.413A.606.606,0,0,1,469.974,263.7Z"
                                                                                transform="translate(-462.279 -252.153)"
                                                                                fill="#7489a1"
                                                                            />
                                                                            <path
                                                                                id="Path_223"
                                                                                data-name="Path 223"
                                                                                d="M428.591,683.949h-1.283a.641.641,0,0,1,0-1.283h1.283a.641.641,0,1,1,0,1.283Z"
                                                                                transform="translate(-420.254 -672.406)"
                                                                                fill="#7489a1"
                                                                            />
                                                                        </svg>
                                                                        Text (Part of the image)
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item
                                                                        onClick={() => {
                                                                            setCropperModal("labels");
                                                                            setImageAnalyzeTab("labels");
                                                                        }}
                                                                    >
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="17.196"
                                                                            height="17.196"
                                                                            viewBox="0 0 17.196 17.196"
                                                                        >
                                                                            <path
                                                                                id="object-group-svgrepo-com"
                                                                                d="M18.336,16.014V5.181A1.664,1.664,0,0,0,19.2,3.72,1.725,1.725,0,0,0,17.476,2a1.664,1.664,0,0,0-1.462.86H5.181A1.664,1.664,0,0,0,3.72,2,1.725,1.725,0,0,0,2,3.72a1.664,1.664,0,0,0,.86,1.462V16.014A1.664,1.664,0,0,0,2,17.476,1.725,1.725,0,0,0,3.72,19.2a1.664,1.664,0,0,0,1.462-.86H16.014a1.664,1.664,0,0,0,1.462.86,1.725,1.725,0,0,0,1.72-1.72A1.664,1.664,0,0,0,18.336,16.014Zm-1.72,0a2.009,2.009,0,0,0-.6.6H5.181a2.009,2.009,0,0,0-.6-.6V5.181a2.009,2.009,0,0,0,.6-.6H16.014a2.009,2.009,0,0,0,.6.6Zm-4.3-8v-.86a.812.812,0,0,0-.86-.86h-4.3a.812.812,0,0,0-.86.86v4.3a.812.812,0,0,0,.86.86h.86V9.738a1.725,1.725,0,0,1,1.72-1.72Zm1.72.86h-4.3a.812.812,0,0,0-.86.86v4.3a.812.812,0,0,0,.86.86h4.3a.812.812,0,0,0,.86-.86v-4.3A.812.812,0,0,0,14.037,8.878Z"
                                                                                transform="translate(-2 -2)"
                                                                                fill="#7489a1"
                                                                            />
                                                                        </svg>
                                                                        Object (Part of the image)
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </li>
                                                </ul>
                                                <div className="search-editable-pop">
                                                    <input
                                                        className="search-editable-pop"
                                                        type="text"
                                                        placeholder="Search..."
                                                        value={searchValue}
                                                        onChange={event => {
                                                            if (event?.target?.value === "") handleInputChange(event);
                                                            setSearchValue(event.target.value);
                                                        }}
                                                        onKeyDown={event => {
                                                            if (event.key === "Enter") {
                                                                handleInputChange(event);
                                                            }
                                                        }}
                                                    />
                                                    <span
                                                        class="close-sr"
                                                        onClick={() => {
                                                            setEditableItem(false);
                                                            setParams({ ...params, search: "" });
                                                            setSearchValue("");
                                                        }}
                                                    >
                                                        <i class="fa fa-times"></i>
                                                    </span>
                                                </div>
                                                <button
                                                    className={`${
                                                        imageAnalyzeTab === "text"
                                                            ? !originalText?.length
                                                                ? "cursor-disabled"
                                                                : "hand-cursor"
                                                            : !originalObjects?.length
                                                            ? "cursor-disabled"
                                                            : "hand-cursor"
                                                    } button-del-all`}
                                                    onClick={() => setDeleteAll(true)}
                                                    data-tip="Delete All"
                                                    data-effect="solid"
                                                    data-place="left"
                                                    disabled={
                                                        imageAnalyzeTab === "text"
                                                            ? !originalText?.length
                                                            : imageAnalyzeTab === "labels"
                                                            ? !originalObjects?.length
                                                            : false
                                                    }
                                                >
                                                    <i className="far fa-trash-alt" />
                                                </button>

                                                <ul>
                                                    <InfiniteScroll
                                                        dataLength={getAnalyseResponse?.results?.length || 0}
                                                        next={handleScrollEnd}
                                                        hasMore={getAnalyseResponse?.results?.length !== getAnalyseResponse?.total}
                                                        height={450}
                                                        loader={
                                                            <div className="col-12">
                                                                <Loader />
                                                            </div>
                                                        }
                                                        className={`list-detail pt-0  ${
                                                            imageAnalyzeTab === "labels"
                                                                ? originalObjects?.length === 0
                                                                    ? "no-data"
                                                                    : ""
                                                                : originalText?.length === 0
                                                                ? "no-data"
                                                                : ""
                                                        }`}
                                                        endMessage={<p style={{ textAlign: "center" }}></p>}
                                                    >
                                                        {imageAnalyzeTab === "text" ? (
                                                            originalText?.length > 0 ? (
                                                                originalText.map((item, i) => (
                                                                    <>
                                                                        <li
                                                                            className={`${editableItem === i ? "input-section-band" : ""} ${
                                                                                i === 0 && "mt-2"
                                                                            } ${showErrorBorder && editableItem === i ? "error-border " : ""}`}
                                                                            key={i}
                                                                        >
                                                                            {editableItem === i ? (
                                                                                <div ref={inputRef} className="analyse-field">
                                                                                    <input
                                                                                        type="text"
                                                                                        value={item}
                                                                                        onChange={e => {
                                                                                            handleEditChange(e, i, "text");
                                                                                        }}
                                                                                        autoFocus
                                                                                        onKeyDown={e => {
                                                                                            if (e.key === "Enter") {
                                                                                                handleSaveChanges(imageAnalyzeTab, "save");
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                    <div className="btn-icons-out">
                                                                                        <button
                                                                                            type="button"
                                                                                            className={`btn-save-tick ${
                                                                                                isEditDisabled ? "cursor-disabled" : ""
                                                                                            }`}
                                                                                            onClick={() => handleSaveChanges(imageAnalyzeTab, "save")}
                                                                                            disabled={isEditDisabled}
                                                                                        >
                                                                                            <i class="fa fa-check" currentitem="false"></i>
                                                                                        </button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className={`btn-save-close`}
                                                                                            onClick={() => {
                                                                                                setEditableItem(false);
                                                                                                setOriginalObjects(savedData?.object);
                                                                                                setOriginalText(savedData?.text);
                                                                                            }}
                                                                                        >
                                                                                            <i class="fa fa-times" currentitem="false"></i>
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            ) : (
                                                                                <div className="list-band">
                                                                                    {item}
                                                                                    <div>
                                                                                        <div
                                                                                            class={`icon mr-2 cursor-hand`}
                                                                                            onClick={() => {
                                                                                                setEditableItem(i);
                                                                                                setAlertMessage("");
                                                                                                dispatch(actions?.ClearPatchImageAnalysisData(false));
                                                                                                dispatch(
                                                                                                    actions?.getAwsRekognition(
                                                                                                        {
                                                                                                            limit: getAnalyseResponse?.total || 100,
                                                                                                            offset: 0,
                                                                                                            process_type: imageAnalyzeTab,
                                                                                                            img_type: "image_upload",
                                                                                                            ...(isSurveyAssetImage &&
                                                                                                                !isAssignedAssetImage && {
                                                                                                                    type: "survey_image_upload"
                                                                                                                }),
                                                                                                            ...(isMobRecom && {
                                                                                                                type: "image_upload"
                                                                                                            })
                                                                                                        },
                                                                                                        selectedImg?.id,
                                                                                                        true
                                                                                                    )
                                                                                                );
                                                                                            }}
                                                                                        >
                                                                                            <i
                                                                                                class="fa fa-pencil-alt"
                                                                                                data-tip="Edit"
                                                                                                data-for="analyse"
                                                                                                data-effect="solid"
                                                                                            ></i>
                                                                                        </div>
                                                                                        <div
                                                                                            class="icon mr-2 cursor-hand"
                                                                                            onClick={() => {
                                                                                                setShowDeleteConfirmModal(i);
                                                                                                setAlertMessage("");
                                                                                            }}
                                                                                        >
                                                                                            <i
                                                                                                class="fa fa-trash"
                                                                                                data-tip="Remove"
                                                                                                data-for="analyse"
                                                                                                data-effect="solid"
                                                                                            ></i>
                                                                                        </div>
                                                                                        <CopyToClipboard
                                                                                            text={item}
                                                                                            onCopy={() => {
                                                                                                setCopySuccessIndex(i);
                                                                                                setTimeout(() => {
                                                                                                    setCopySuccessIndex(false);
                                                                                                }, 3500);
                                                                                            }}
                                                                                        >
                                                                                            <div class="icon cursor-hand">
                                                                                                {copySuccessIndex === i ? (
                                                                                                    <i
                                                                                                        class="fa fa-check"
                                                                                                        style={{ color: "green" }}
                                                                                                        data-tip={"Copied to Clipboard"}
                                                                                                        data-effect="solid"
                                                                                                        data-for="analyse"
                                                                                                        data-place="left"
                                                                                                    ></i>
                                                                                                ) : (
                                                                                                    <i
                                                                                                        class="fa fa-copy"
                                                                                                        onClick={() => showAlert()}
                                                                                                        data-tip={"Click to Copy"}
                                                                                                        data-effect="solid"
                                                                                                        data-for="analyse"
                                                                                                        data-place="left"
                                                                                                    ></i>
                                                                                                )}
                                                                                            </div>
                                                                                        </CopyToClipboard>
                                                                                        <ReactTooltip
                                                                                            clickable={false}
                                                                                            id="analyse"
                                                                                            effect="solid"
                                                                                            place="top"
                                                                                            className="rc-tooltip-custom-class"
                                                                                            backgroundColor="#111314"
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </li>
                                                                    </>
                                                                ))
                                                            ) : (
                                                                <div className="no-data-outer">
                                                                    <img src={noDataForAnalysis} alt="No data for analysis" />
                                                                    <h3>No data Found</h3>
                                                                </div>
                                                            )
                                                        ) : originalObjects?.length > 0 ? (
                                                            originalObjects?.map((item, i) => (
                                                                <li
                                                                    className={`${editableItem === i ? "input-section-band" : ""} ${
                                                                        i === 0 && "mt-2"
                                                                    }`}
                                                                    key={i}
                                                                >
                                                                    {editableItem === i ? (
                                                                        <div ref={inputRef} className="analyse-field">
                                                                            <input
                                                                                type="text"
                                                                                value={item}
                                                                                onChange={e => handleEditChange(e, i, "object")}
                                                                                autoFocus
                                                                                onKeyDown={e => {
                                                                                    if (e.key === "Enter") {
                                                                                        handleSaveChanges(imageAnalyzeTab, "save");
                                                                                    }
                                                                                }}
                                                                            />
                                                                            <div className="btn-icons-out">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn-save-tick"
                                                                                    onClick={() => handleSaveChanges(imageAnalyzeTab, "save")}
                                                                                >
                                                                                    <i class="fa fa-check" currentitem="false"></i>
                                                                                </button>
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn-save-close"
                                                                                    onClick={() => {
                                                                                        setEditableItem(false);
                                                                                        setOriginalObjects(savedData?.object);
                                                                                        setOriginalText(savedData?.text);
                                                                                    }}
                                                                                >
                                                                                    <i class="fa fa-times" currentitem="false"></i>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="list-band">
                                                                            {item}
                                                                            <div>
                                                                                <div
                                                                                    class="icon mr-2 cursor-hand"
                                                                                    onClick={() => {
                                                                                        setEditableItem(i);
                                                                                        setAlertMessage("");
                                                                                        dispatch(
                                                                                            actions?.getAwsRekognition(
                                                                                                {
                                                                                                    limit: getAnalyseResponse?.total || 100,
                                                                                                    offset: 0,
                                                                                                    process_type: imageAnalyzeTab,
                                                                                                    img_type: "image_upload",
                                                                                                    ...(isSurveyAssetImage &&
                                                                                                        !isAssignedAssetImage && {
                                                                                                            type: "survey_image_upload"
                                                                                                        }),
                                                                                                    ...(isMobRecom && {
                                                                                                        type: "image_upload"
                                                                                                    })
                                                                                                },
                                                                                                selectedImg?.id,
                                                                                                true
                                                                                            )
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    <i
                                                                                        class="fa fa-pencil-alt"
                                                                                        data-tip="Edit"
                                                                                        data-effect="solid"
                                                                                        data-for="analyse"
                                                                                    ></i>
                                                                                </div>
                                                                                <div
                                                                                    class="icon mr-2 cursor-hand"
                                                                                    onClick={() => {
                                                                                        setShowDeleteConfirmModal(i);
                                                                                        setAlertMessage("");
                                                                                    }}
                                                                                >
                                                                                    <i
                                                                                        class="fa fa-trash"
                                                                                        data-tip="Remove"
                                                                                        data-effect="solid"
                                                                                        data-for="analyse"
                                                                                    ></i>
                                                                                </div>
                                                                                <CopyToClipboard
                                                                                    text={item}
                                                                                    onCopy={() => {
                                                                                        setCopySuccessIndex(i);
                                                                                        setTimeout(() => {
                                                                                            setCopySuccessIndex(false);
                                                                                        }, 3500);
                                                                                    }}
                                                                                >
                                                                                    <div class="icon cursor-hand">
                                                                                        {copySuccessIndex === i ? (
                                                                                            <i
                                                                                                class="fa fa-check"
                                                                                                data-for="analyse"
                                                                                                style={{ color: "green" }}
                                                                                                data-tip={"Copied to Clipboard"}
                                                                                                data-effect="solid"
                                                                                                data-place="left"
                                                                                            ></i>
                                                                                        ) : (
                                                                                            <i
                                                                                                class="fa fa-copy"
                                                                                                data-for="analyse"
                                                                                                onClick={() => showAlert()}
                                                                                                data-tip={"Click to Copy"}
                                                                                                data-effect="solid"
                                                                                                data-place="left"
                                                                                            ></i>
                                                                                        )}
                                                                                    </div>
                                                                                </CopyToClipboard>
                                                                                <ReactTooltip
                                                                                    clickable={false}
                                                                                    id="analyse"
                                                                                    place="top"
                                                                                    effect="solid"
                                                                                    className="rc-tooltip-custom-class"
                                                                                    backgroundColor="#007bff"
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </li>
                                                            ))
                                                        ) : (
                                                            <div className="no-data-outer">
                                                                <img src={noDataForAnalysis} alt="No data for analysis" />
                                                                <h3>No data Found</h3>
                                                            </div>
                                                        )}
                                                        <ReactTooltip
                                                            place="top"
                                                            className="rc-tooltip-custom-class"
                                                            effect="solid"
                                                            backgroundColor="#007bff"
                                                        />
                                                    </InfiniteScroll>
                                                </ul>
                                            </div>
                                        </div>
                                    </LoadingOverlay>
                                ) : (
                                    <ul className="label-notification">
                                        {selectedImg.labels?.map(item => (
                                            <li key={item.name}>{item.name}</li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                            <ReactTooltip
                                id={`${selectedImg.id}-view`}
                                effect="solid"
                                place="left"
                                backgroundColor="#1383D9"
                                getContent={dataTip => (dataTip ? sanitizeHtml(dataTip) : "")}
                                html={true}
                                multiline={true}
                            />
                        </div>
                    </div>
                </div>
            </Draggable>
            {renderMenuSwitchConfirmationModal()}
            {renderConfirmationModal()}
            {renderCropperModal()}
        </div>
    );
}

const mapStateToProps = state => {
    const { imageReducer } = state;
    return { imageReducer };
};

export default withRouter(connect(mapStateToProps, { ...actions })(ImageViewModal));
